import { useState } from "react";

import {
    IconChevronDown,
    IconChevronUp,
    IconTrophy,
} from "@tabler/icons-react";

import { Text } from "@fragments";

import "./styles.scss";

function AwardRow({ award, index }) {
    return (
        <div className="award-row">
            {award.banner ? (
                <img src={award.banner} className="award-row__banner" alt="" />
            ) : (
                <div className="award-row__banner award-row__banner--placeholder">
                    <IconTrophy size={16} />
                </div>
            )}
            <Text.span contrast={7}>
                <Text.span contrast={8} className="bold">
                    #{index + 1}:{" "}
                </Text.span>
                {award.title}
            </Text.span>
        </div>
    );
}

export default function Awards({ awards }) {
    const [showAll, setShowAll] = useState(false);

    if (!awards?.length) return null;

    const visible = showAll ? awards : [awards[0]];

    return (
        <div className="challenge-awards">
            <div className="challenge-awards__header">
                <Text.h4 contrast={8} left={<IconTrophy size={18} />}>
                    Premiações finais
                </Text.h4>
                <button className="awards-toggle" onClick={() => setShowAll(!showAll)}>
                    <Text.span contrast={5}>{showAll ? "Ocultar" : "Ver tudo"}</Text.span>
                    {showAll ? (
                        <IconChevronUp size={14} />
                    ) : (
                        <IconChevronDown size={14} />
                    )}
                </button>
            </div>

            <div className="challenge-awards__list">
                {visible.map((award, i) => (
                    <AwardRow key={i} award={award} index={i} />
                ))}
            </div>

            {!showAll && awards.length > 1 && (
                <Text.span contrast={6} className="awards-more-hint">
                    + {awards.length - 1}{" "}
                    {awards.length - 1 === 1 ? "prêmio" : "prêmios"}
                </Text.span>
            )}
        </div>
    );
}
